import {
  Slider as MUISlider,
  SliderProps,
  Stack,
  styled,
  Typography,
} from '@mui/material'
import { SxProps } from '@mui/system'
import { useMemo } from 'react'

import { Organism, OrganismFrame } from '@/core/architecture'

type CollectionIndicatorProps = {
  itemCount: number
  totalCount: number
  sx?: SxProps
  successColor?: SliderProps['color']
}

export const CollectionIndicator: Organism<CollectionIndicatorProps> = ({
  itemCount = 0,
  totalCount = 1,
  sx,
  successColor = 'primary',
}) => {
  const itemCompletionRatio = useMemo(
    () => (!totalCount ? 0 : (itemCount / totalCount) * 100),
    [itemCount, totalCount]
  )
  return (
    <OrganismFrame>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          mx: 4,
          pt: 1,
          pb: 2,
          color: 'background.default',
          alignItems: 'center',
          ...sx,
        }}
      >
        <Slider
          sx={{ flex: 1 }}
          value={itemCompletionRatio}
          color={itemCount === totalCount ? successColor : 'primary'}
        />
        <Typography variant="subtitle2" sx={{ ml: 4, minWidth: 36 }}>
          {itemCount}/{totalCount}
        </Typography>
      </Stack>
    </OrganismFrame>
  )
}

const Slider = styled(MUISlider)(({ theme }) => {
  return {
    '&.MuiSlider-colorPrimary': {
      height: 16,
      padding: 0,
      width: '100%',
      color: theme.palette.primary.main,
    },
    '&.MuiSlider-colorSecondary': {
      height: 16,
      padding: 0,
      width: '100%',
      color: theme.palette.secondary.main,
    },
    '> .MuiSlider-thumb': {
      display: 'none',
    },
    '> .MuiSlider-active': {},
    '> .MuiSlider-valueLabel': {
      left: 'calc(-50% + 4px)',
    },
    '> .MuiSlider-track': {
      height: 6,
      borderLeftWidth: 0,
      borderRightWidth: 0,
    },
    '.MuiSlider-rail': {
      height: 8,
      borderRadius: 4,
      color: 'white',
    },
  }
})
